const STATUS_STYLES = {
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  Complete: "bg-green-50 text-green-700 border-green-200",
  Failed: "bg-red-50 text-red-700 border-red-200",
};

const CsvStatusBadge = ({ status }) => (
  <span
    className={`inline-flex rounded-full border px-3 py-0.5 text-xs font-UbuntuMedium ${
      STATUS_STYLES[status] || STATUS_STYLES.Pending
    }`}
  >
    {status}
  </span>
);

export default CsvStatusBadge;
